import React from 'react'
import Sbar from './Sbar'
import Feed from '../Global/Feed'
import Searchbar from '../Global/Searchbar'
/* REDUX */
import { connect } from 'react-redux'
import { loadSearch } from '../../actions/search'

const loadData = ({ query, filter, loadSearch }, refresh) => {
	loadSearch(query, filter, false, refresh)
}

class Content extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			lastSearch: ''
		}
	}

	componentWillMount() {
		loadData(this.props, true)
		this.setState({
			lastSearch: this.props.query
		})
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.query !== this.props.query) {
			loadData(nextProps, true)
			this.setState({
				lastSearch: nextProps.query
			})
		} else if (nextProps.query === this.props.query && nextProps.filter !== this.props.filter) {
			loadData(nextProps, false)
		}
	}

	handleLoadMoreClick = () => {
		this.props.loadSearch(this.props.query, this.props.filter, true, false)
	}

	render() {

		const { filter, reports, endOfDoc, pathname, query } = this.props

		if (!reports) {
			return <div></div>
		}

		return (
			<section className="content height-x">
				<div className="container">
					<div className="row">
						<div className="col-12 col-lg-2">
							<Sbar pathname={ pathname } query={ query } filter={ filter} />
						</div>
						<div className="col-12 col-lg-3 push-lg-7">
							<Searchbar />
						</div>
						<div className="col-12 col-lg-7 pull-lg-3">
							<Feed feed={ `Search results for "${query}"` } reports={ reports } onLoadMoreClick={ this.handleLoadMoreClick } endOfDoc={ endOfDoc } onLogin={ this.props.onLogin } />
						</div>
					</div>
				</div>
			</section>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const params = new URLSearchParams(ownProps.search)
	const query = params.get('q')
	const filter = params.get('t') ? params.get('t') : 'relevance'
	const {
		searchByFilter
	} = state
	const resultsWrapper = searchByFilter[filter] || {}
	const results = resultsWrapper.results
	const endOfDoc = resultsWrapper.endOfDoc
	return {
		query,
		filter,
		reports: results,
		endOfDoc
	}
}

export default connect(mapStateToProps, { loadSearch })(Content)



// WEBPACK FOOTER //
// ./src/components/Search/Content.js